<template>
    <!-- 命令统计 -->
    <div style="width: 100%; height: 100%" id="command"></div>
</template>

<script setup>
import { defineProps, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import * as echarts from 'echarts'

const props = defineProps({
    sourceData: {
        type: Array
    }
})
const options = ref({})
const charts = { chart: null }

const initChart = () => {
    options.value = {
        tooltip: {
            trigger: 'item'
        },
        series: [
            {
                name: '命令',
                type: 'pie',
                radius: [50, 160],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                    borderRadius: 8
                },
                data: props.sourceData
            }
        ]
    }
    charts.chart.setOption(options.value)
    window.addEventListener('resize', () => {
        charts.chart.resize()
    })
}

onMounted(() => {
    charts.chart = echarts.init(document.getElementById('command'))
    initChart()
})
onBeforeUnmount(() => {
    charts.chart.dispose()
})
// initChart()
watch(
    () => props.sourceData,
    (newVal) => {
        // console.log(newVal)
        if (props.sourceData.length > 0) {
            initChart()
        }
    },
    { deep: true }
)
watch(
    () => props.yMax,
    (newVal) => {
        initChart()
    }
)
</script>

<style lang="scss" scoped>
#command {
    padding: 0.052083rem /* 10/192 */;
}
</style>
